import { c as _c } from "react/compiler-runtime";
import type { Account, RestoreAccount, SourceAccount } from '@repo/api-gw-sdk';
import { CloudProviders } from '@/data/inventory/data';
import type { MultiSelectConditionComponentProps } from '@/types/advanceFilter';
import { getAccountProvider } from '@/utils/accounts';
import { MultiSelectConditionPanel } from '../conditions/conditionComponents';
import { CircleImage } from '../shared/circleImage';
export const AccountCondition = props => {
  const $ = _c(15);
  const matchesName = props.matchOn === "name";
  const t0 = props.isLoading ?? false;
  let t1;
  if ($[0] !== props.entityName || $[1] !== props.property) {
    t1 = props.entityName || props.property.displayName.toLowerCase();
    $[0] = props.entityName;
    $[1] = props.property;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props.accounts) {
    t2 = props.accounts || [];
    $[3] = props.accounts;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== matchesName || $[6] !== t2) {
    let t4;
    if ($[8] !== matchesName) {
      t4 = account => {
        const cloudProvider = getAccountProvider(account);
        return {
          id: matchesName ? account.name : account.providerAccountId,
          name: matchesName ? account.providerAccountId : account.name,
          Image: CloudProviders[cloudProvider] && <CircleImage alt={CloudProviders[cloudProvider].displayName} src={CloudProviders[cloudProvider].logo} className="my-[16px]" />
        };
      };
      $[8] = matchesName;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t3 = t2.map(t4);
    $[5] = matchesName;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[10] !== props || $[11] !== t0 || $[12] !== t1 || $[13] !== t3) {
    t4 = <MultiSelectConditionPanel showAddNewButton={true} showSearchBox={true} isLoading={t0} entityName={t1} shouldShowId={true} options={t3} {...props} />;
    $[10] = props;
    $[11] = t0;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};